var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CardSuit from "@/components/CardSuit";
import { ActionTypeTagColors } from "@/pages/transaction-management/TransactionManagement.constants";
import { getCardDetails } from "@/utils/card";
import { deleteTenant } from "@/utils/string";
import { Tag } from "@atom/ui-kit";
import { Space, Typography } from "antd";
import dayjs from "dayjs";
import { Cards, Text } from "../../../MoreInfoDrawer/_components/OnlineTableView/_components/OnlinePlayersInfoCard/OnlinePlayersInfoCard.style";
import { PlayerName, WinnerRow } from "./RoundTransactionTable.style";
var Link = Typography.Link;
export var columns = function (t) { return [
    {
        title: t("transactionManagement.detailDrawer.roundTransactions.username"),
        dataIndex: "name",
        key: "name",
        width: 40,
        render: function (text, record) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var winner = (_b = (_a = record.game.winnerResult) === null || _a === void 0 ? void 0 : _a.winners) === null || _b === void 0 ? void 0 : _b[0];
            var player = ((_d = (_c = winner === null || winner === void 0 ? void 0 : winner.winnerSeat) === null || _c === void 0 ? void 0 : _c.player) === null || _d === void 0 ? void 0 : _d.nickname) || ((_f = (_e = winner === null || winner === void 0 ? void 0 : winner.winnerSeat) === null || _e === void 0 ? void 0 : _e.player) === null || _f === void 0 ? void 0 : _f.username) || ((_h = (_g = record === null || record === void 0 ? void 0 : record.session) === null || _g === void 0 ? void 0 : _g.user) === null || _h === void 0 ? void 0 : _h.username) || (record === null || record === void 0 ? void 0 : record.tenant_userid);
            console.log(winner, "winner", player);
            return (_jsxs(PlayerName, { children: [_jsx(Link, { children: deleteTenant(player) }), winner && _jsx(WinnerRow, { children: t("root.won") })] }));
        },
    },
    {
        title: t("transactionManagement.detailDrawer.roundTransactions.type"),
        dataIndex: "type",
        key: "type",
        width: 40,
        render: function (value) { return (_jsx(Tag, { style: {
                color: "white",
            }, color: ActionTypeTagColors[value] || "default", children: t("transactionManagement.columns.userAction.".concat(value)) })); },
    },
    {
        title: t("transactionManagement.detailDrawer.roundTransactions.amount"),
        dataIndex: "amount",
        key: "amount",
        width: 40,
        render: function (amount, record) {
            return amount ? (_jsxs(Text, { type: "chips", children: [amount, " ", record.game.currency] })) : (_jsx(Text, { type: "secondary", children: "-" }));
        },
    },
    {
        title: t("transactionManagement.detailDrawer.roundTransactions.combination"),
        dataIndex: "combination",
        key: "combination",
        width: 90,
        render: function (_, record) {
            var _a, _b;
            var cards = (_b = __spreadArray(__spreadArray([], (((_a = record.game.state.currentTurn) === null || _a === void 0 ? void 0 : _a.cards) || []), true), (record.game.state.communityCards || []), true)) === null || _b === void 0 ? void 0 : _b.map(function (card) { return getCardDetails(card); });
            return (_jsx(Space, { size: "small", children: cards === null || cards === void 0 ? void 0 : cards.map(function (card, index) { return (_jsxs(Cards, { index: index, isRed: card.color == "Red", children: [_jsx(CardSuit, { suit: card.suit }), _jsx("span", { children: card.value })] }, index)); }) }));
        },
    },
    {
        title: t("transactionManagement.detailDrawer.roundTransactions.activityDate"),
        dataIndex: "timestamp",
        key: "timestamp",
        width: 120,
        render: function (text) { return dayjs(text * 1000).format("YYYY-MM-DD HH:mm:ss"); },
    },
]; };
